
export const featuresEs = {
  // General
  features: 'Características',
  feature: 'Característica',
  featureManagement: 'Gestión de Características',
  manageFeatures: 'Administrar características del sistema y acceso premium',
  
  // Feature properties
  featureKey: 'Clave de Característica',
  featureName: 'Nombre de Característica',
  featureDescription: 'Descripción',
  premiumFeature: 'Característica Premium',
  
  // Actions
  addFeature: 'Agregar Característica',
  editFeature: 'Editar Característica',
  deleteFeature: 'Eliminar Característica',
  createFeature: 'Crear Característica',
  updateFeature: 'Actualizar Característica',
  
  // Messages
  featureCreated: 'Característica creada exitosamente',
  featureUpdated: 'Característica actualizada exitosamente',
  featureDeleted: 'Característica eliminada exitosamente',
  
  // Errors
  errorFetchingFeatures: 'Error al obtener características',
  errorCreatingFeature: 'Error al crear característica',
  errorUpdatingFeature: 'Error al actualizar característica',
  errorDeletingFeature: 'Error al eliminar característica',
  
  // Validation
  keyRequired: 'La clave de característica es requerida',
  nameRequired: 'El nombre de característica es requerido',
  keyAlreadyExists: 'Esta clave de característica ya existe',
  keyInvalidFormat: 'La clave debe estar en formato snake_case',
  nameTooShort: 'El nombre debe tener al menos 2 caracteres',
  nameTooLong: 'El nombre debe tener menos de 100 caracteres',
  descriptionTooLong: 'La descripción debe tener menos de 500 caracteres',
  
  // Tooltips
  featureKeyTooltip: 'Identificador único para la característica (snake_case)',
  featureNameTooltip: 'Nombre mostrado para la característica',
  featureDescriptionTooltip: 'Descripción opcional de la característica',
  isPremiumTooltip: 'Si esta característica requiere suscripción premium',
  
  // Dialogs
  createNewFeatureDescription: 'Crear una nueva característica para el sistema',
  editFeatureDescription: 'Editar la característica seleccionada',
  deleteFeatureConfirm: '¿Estás seguro de que quieres eliminar esta característica? Esta acción no se puede deshacer.',
  
  // Access
  accessDenied: 'Acceso Denegado',
  adminAccessRequired: 'Se requiere acceso de administrador',
  noPermissionToView: 'No tienes permisos para ver esta página',
  
  // Search and filters
  searchFeatures: 'Buscar características...',
  allFeatures: 'Todas las Características',
  freeFeatures: 'Características Gratuitas',
  premiumFeatures: 'Características Premium',
  clearFilters: 'Limpiar Filtros',
  
  // Stats
  totalFeatures: 'Total de Características',
  freeCount: 'Gratuitas',
  premiumCount: 'Premium',
};
